<template>
    <el-row class="container_self">
        <el-row class="table_parent">
            <el-row class="add_btn"><el-button type="primary" icon="el-icon-plus" size="mini" @click="createUser" v-if="permissions.indexOf(22)!=-1">新增用户</el-button></el-row>

            <el-row class="search_parent">
                <!-- <el-row>搜索</el-row> -->
                <el-input v-model="searchName" size="mini" clearable placeholder="请输入用户名称"></el-input>
                <el-button type="warning" size="mini" icon="el-icon-search" @click="search">搜索</el-button>
            </el-row>
            <el-row>
                <el-table :data="tableData"  style="width: 100%; margin-top: 10px"  v-loading="loading"  element-loading-text="加载中，请稍后">
                    <el-table-column prop="name" label="用户名称"  width="80" align="center"></el-table-column>
                    <el-table-column label="登录账号" width="180"  align="center" prop="email"></el-table-column>
                    <!-- <el-table-column label="登录密码" width="180"  align="center" prop="password"></el-table-column> -->
                    <!-- <el-table-column label="角色" width="80"  align="center" prop="roles"></el-table-column> -->
                    <el-table-column label="状态" width="80"  align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.enabled?"可用":"不可用" }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="国家" align="center" prop="country"></el-table-column>
                    <el-table-column prop="state" label="所在州"  align="center"></el-table-column>
                    <el-table-column label="所在城市"  align="center" prop="city"></el-table-column>
                    <el-table-column label="地址一" width="220" prop="address1" align="center"></el-table-column>
                    <el-table-column label="地址二" width="220" prop="address2" align="center"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间"  align="center"></el-table-column>
                    <el-table-column label="操作"  align="center" v-if="permissions.indexOf(23)!=-1" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="editUser(scope.row)">修改</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </el-row>
        </el-row>


        <el-dialog :title="string+'用户'" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm" size="mini" class="demo-ruleForm">
                <el-form-item label="用户名" prop="name">
                    <el-input  v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="email">
                    <el-input  v-model="form.email" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="登录密码" prop="password">
                    <el-input  v-model="form.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="roles">
                    <!-- <el-input  v-model="form.password" autocomplete="off"></el-input> -->
                    <el-select v-model="form.roles"  multiple ><!-- :disabled="edit"-->
                        <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否可用">
                    <el-select v-model="form.enabled">
                        <el-option label="可用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="所在国家">
                    <el-input  v-model="form.country" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="所在州">
                    <el-input  v-model="form.state" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="所在城市">
                    <el-input  v-model="form.city" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="地址一">
                    <el-input  v-model="form.address1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="地址二">
                    <el-input  v-model="form.address2" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="地区邮编">
                    <el-input  v-model="form.zipcode" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')" size="mini">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </el-row>
</template>

<script>
    import {axiosGet,axiosPost} from '@/assets/ajaxFn'
    export default {
        data(){
            return{
                total:0,
                searchName:'',
                pageSize:50,
                tableData: [],
                loading:false,
                    currentPage:1,
                    dialogFormVisible:false,
                    form:{
                        name:'',
                        email:'',
                        password:'',
                        country:'',
                        state:'',
                        city:'',
                        ext:'',
                        address1:'',
                        address2:'',
                        zipcode:'',
                        roles:[],
                        enabled:1
                    },
                    rules:{
                        name: [
                            { required: true, message: '请输入用户名称', trigger: 'blur' },
                            { min: 1, max: 25, message: '长度在 1 到 25 个字符', trigger: 'blur' }
                        ],
                        email: [
                            { required: true, message: '请输入email作为登录账号', trigger: 'blur' }
                        ],
                        password:[
                            { required: true, message: '请输入登录密码', trigger: 'blur' }
                        ],
                        roles:[
                            { required: true, message: '请选择角色', trigger: 'blur' }
                        ]
                    },
                    edit:false,
                    id:'',
                    roles:[],
                    permissions:JSON.parse(sessionStorage.getItem('permission')),
                    string:"新增"
            }
        },
        methods:{
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getUseromList({currentPage:this.currentPage,pageSize:this.pageSize,keyword:this.searchName});
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getUseromList({currentPage:this.currentPage,pageSize:this.pageSize,keyword:this.searchName});
            },
            search(){
                this.currentPage=1;
                this.pageSize=50;
                this.getUseromList({currentPage:1,pageSize:50,keyword:this.searchName});
            },
            createUser(){
                this.string="新增";
                this.dialogFormVisible=true;
            },
            addItem(arr,item){//新增白名单ip
                if(arr.length>8){
                    this.$message({message:'最多可以添加9个',type:'error'});
                    return false;
                }
                arr.push({
                    value: '',
                    key: Date.now(),
                    showAdd:true,
                    showMin:true
                });
                arr[0].showAdd=false;
                arr[0].showMin=false;
                let index=arr.indexOf(item);
                if(index!=0){
                    arr[index].showAdd=false;
                    arr[index].showMin=true;
                }
            },
            removeItem(arr,item){
                let index=arr.indexOf(item)
                if(index!=0){
                    arr.splice(index,1);
                    arr[arr.length-1].showAdd=true;
                }

            },
            editUser(item){
                this.string="修改"
                this.form=JSON.parse(JSON.stringify(item));
                this.id=item.id;
                this.edit=true;
                axiosGet('/api/user/info',{id:item.id}).then(res=>{
                    if(res.code==0){
                        this.form=res.data;
                        this.dialogFormVisible=true;
                        
                        // 触发移除密码验证
                        this.$nextTick( ()=> {
                            this.rules['password']=[];
                            this.rules['email']=[];
                        })
                        
                       
                    }
                })
                
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    let addCustomRequest={
                        name:this.form.name,
                        country:this.form.country||'',
                        state:this.form.state||'',
                        city:this.form.city||'',
                        ext:this.form.ext||'',
                        address1:this.form.address1||'',
                        address2:this.form.address2||'',
                        zipcode:this.form.zipcode||'',
                        roles:this.form.roles,
                        enabled:this.form.enabled
                    }
                    let url='',string='';
                    if(!this.edit){
                        addCustomRequest.email=this.form.email;
                        addCustomRequest.password=this.form.password;
                        
                        url='/api/user/add';
                        string="添加";
                    }else{
                        url='/api/user/update'
                        string="修改";
                        addCustomRequest.id=this.id;
                    }
                    axiosPost(url,addCustomRequest,'JSON').then(res=>{
                        if(res.code==0){
                            this.$message({message:`用户${string}成功`,type:'success'});
                            this.getUseromList({currentPage:1,pageSize:50});
                            this.dialogFormVisible=false;
                            this.edit=false;
                            this.id="";
                            this.resetForm('ruleForm')
                        }
                    })
                    
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.dialogFormVisible=false;
                let _this=this;
                setTimeout(function(){//此定时器是为了防止页面UI抖动，可移除
                    _this.showclient=true;
                    _this.edit=false;
                    _this.form={
                        name:'',
                        email:'',
                        password:'',
                        country:'',
                        state:'',
                        city:'',
                        ext:'',
                        address1:'',
                        address2:'',
                        zipcode:'',
                        roles:[],
                        enabled:1
                    }
                },500)
                
            },
            async getUseromList(params){
                this.loading=true;
                let res=await axiosGet('/api/user/list',params);
                this.loading=false;
                if(res.code==0){
                        this.tableData=res.data.records;
                        this.total=res.data.total;
                    }
            }
        },
        mounted() {
           this.getUseromList({currentPage:1,pageSize:50,keyword:this.searchName});
           if(this.permissions.indexOf(16)!=-1){
            axiosGet('/api/role/list').then(res=>{
                if(res.code==0){
                        this.roles=res.data;
                    }
                })
           }
        },
    }
</script>
<style scoped>
    .add{
        display: inline-block;
        width:30px;
        height: 30px;
        line-height: 30px;
        border-radius: 50%;
        background-color: #2698F1;
        color:#fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/view/userManager.vue